import { useHuonekortti } from "@/methods/huonekorttiComposablses";
import { useHuonekorttiHistoria } from "@/methods/huonekorttiHistoriaComposables";
import { ElMessage } from "element-plus";
import { computed, ref, watch } from "vue";

const id = ref<number>()
export function useHistoriaComponent() {
    const { huonekortti, error: huonekorttiError, loading: huonekorttiLoading } = useHuonekortti(id)
    const { historia, error: historiaError, loading: historiaLoading } = useHuonekorttiHistoria(id)
    const loading = computed(() => huonekorttiLoading.value || historiaLoading.value)

    watch(huonekorttiError, val => {
        if(val) {
            ElMessage.error("Huonekortin lataus epäonnistui")
        }
    })
    watch(historiaError, val => {
        if(val) {
            ElMessage.error("Huonekortin historian lataus epäonnistui")
        }
    })


    return {
        historia,
        huonekortti,
        id,
        loading
    }
}